module.exports = __webpack_public_path__ + "fe05a1f96927b29842d50a4d280f7487.pdf";